import { toast } from "react-toastify";
import { RepositoryFactory } from "../../Repository/RepositoryFactory";
import { authLoader, registerLoader } from "./authAction";
import { updateContact } from "./UserActions";
import { COUPON_LOADER } from "../types";

let Subscribe = RepositoryFactory.get("subscribe");
export const getFetchCustomer =
  (stripe_customer_id, onSuccess) => async (dispatch) => {
    try {
      let { data } = await Subscribe.fetchCustomer(stripe_customer_id);

      if (data?.success) {
        onSuccess(data?.data?.data.at(-1));
      } else {
        toast.error(data?.message);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          error?.data?.message ||
          error?.message ||
          "Something Went Wrong"
      );
      console.log("error: ", error);
    }
  };

// export const subscribe = (payload, onSuccess) => async (dispatch) => {
//     try {
//         const res = await Subscribe.subscribePlan(payload);
//     } catch (error) {
//         console.log("error: ", error);
//     }
// };

export const updatePlan =
  (payload, subscriptionPayload, customerId, onSuccess) => async (dispatch) => {
    // dispatch(authLoader(true));

    try {
      if (dispatch(updateContact(payload))) {
        // subscribe(subscriptionPayload);

        await Subscribe.subscribePlan(subscriptionPayload);
        await dispatch(updateContact({}));
        onSuccess();
      }
    } catch (error) {
      // dispatch(authLoader(false));
      dispatch(registerLoader(false));
      toast.error(
        error?.response?.data?.message ||
          error?.data?.message ||
          error.message ||
          "Something Went Wrong"
      );
      console.error(error.message);
    }
  };

export const cancelSubscription = (user_id, onSuccess) => async (dispatch) => {
  dispatch(authLoader(true));
  try {
    await Subscribe.cancelSubscribePlan(user_id).then(async (res) => {
      if (res.data.success) {
        toast.success("Subscription Cancelled Successfully");
        await dispatch(updateContact({}));
        onSuccess();
      } else {
        toast.error(res.data.message);
      }
    });
  } catch (error) {
    console.log("error: ", error);
    toast.error(
      error?.response?.data?.message ||
        error?.data?.message ||
        error.message ||
        "Something Went Wrong"
    );
    // toast.error("Token Expired. Please login again..");
    console.error("Error:", error.message);
  } finally {
    dispatch(authLoader(false));
  }
};

// Remove this since it is never used?
// export const getSubscription =
//     (stripe_customer_id, onSuccess) => async (dispatch) => {
//         try {
//             const subscriptionDetailsResponse =
//                 await Subscribe.subscribeDetails(stripe_customer_id);
//             const subscriptionDetailsData = subscriptionDetailsResponse.data;
//             if (subscriptionDetailsData.success) {
//                 const subscription = subscriptionDetailsData.data[0];
//                 onSuccess(subscription);
//             } else {
//                 toast.error(subscriptionDetailsData.message);
//             }
//         } catch (error) {
//             toast.error(
//                 error?.response?.data?.message ||
//                     error?.data?.message ||
//                     error.message ||
//                     "Something Went Wrong"
//             );
//             console.log("error: ", error);
//         }
//     };

/*
    Check a discount code, and report back WHAT IT IS WORTH (static#74).

    Two separate bugs kept this from ever working:

      1. Here. `res.response.data` is the shape of an axios ERROR, not a
         successful response — a success carries `res.data`. So the success
         path threw, the catch threw again on the same mistake, and onSuccess
         was never called. No code, valid or not, could turn the field green.
      2. In the backend, which looked the string up as a coupon ID when the
         box asks for a promotion code. Fixed in golfbert-backend#106.

    Either one alone breaks coupons, which is why this looked like it "just
    stopped working".

    onSuccess now receives the discount itself (percentOff, amountOff,
    duration, coversEverything) rather than a bare boolean, so the summary can
    show the real price and checkout can skip the card for a 100% code. Null
    means the code was refused.
*/
export const checkCoupon = (coupon, onSuccess) => async (dispatch) => {
  dispatch({ type: COUPON_LOADER, payload: true });
  try {
    const res = await Subscribe.validateCoupon(coupon);
    if (res?.data?.success) {
      onSuccess(res.data.data || null);
    } else {
      toast.error(res?.data?.message || "That code isn't valid.");
      onSuccess(null);
    }
  } catch (error) {
    // A refused code is a 404 with a message worth showing; anything else
    // is ours, and "invalid code" would be a lie.
    const status = error?.response?.status;
    toast.error(
      status === 404
        ? error?.response?.data?.message ||
            "That code isn't valid. Please check it and try again."
        : "We couldn't check that code just now. Please try again."
    );
    onSuccess(null);
  } finally {
    dispatch({ type: COUPON_LOADER, payload: false });
  }
};

export const updateCard = (payload, onSuccess) => async (dispatch) => {
  try {
    await Subscribe.updateCard(payload)
      .then((res) => {
        toast.success("Updated Successfully");
        onSuccess(res?.data?.data);
      })
      .catch((res) => {
        toast.error(res.data.message);
      });
  } catch (error) {
    toast.error(
      error.message || error?.response?.data?.message || "Something Went Wrong"
    );
    console.error("error: ", error);
  } finally {
    dispatch(authLoader(false));
  }
};

export const getUserSubscription =
  (stripe_customer_id, onSuccess) => async (dispatch) => {
    dispatch(authLoader(true));
    try {
      let { data } = await Subscribe.userSubscription(stripe_customer_id);
      // console.log("subscriptionData: ", data);
      if (data) {
        onSuccess(data?.data);
      }
    } catch (error) {
      console.error("error: ", error);
    } finally {
      dispatch(authLoader(false));
    }
  };

/*
    Undo a pending cancel (static#104).

    Cancelling doesn't end a subscription straight away: it is set to end when
    the paid period does. Until then the customer can take it back, and this
    is how. POST /payment/resumeSubscription has no body — the backend finds
    the customer from the token — and keeps the same subscription and renewal
    date, with no new charge.

    Resolves to true only when the server said `success: true`, so the caller
    re-fetches and shows the plan as renewing. Anything else (409 "nothing to
    resume" or "a plan change is scheduled", 404, 500, no network) shows the
    server's message and resolves to false. A failure must never look like a
    success, so there is exactly one success toast and it is behind that
    check.

    No authLoader here: that flag swaps the whole Plans grid for a spinner.
    The button shows its own.
*/
export const resumeSubscription = () => async () => {
  try {
    const { data } = await Subscribe.resumeSubscription();
    if (data?.success === true) {
      toast.success(data.message || "Your plan will renew as usual.");
      return true;
    }
    toast.error(data?.message || "We couldn't resume your plan.");
    return false;
  } catch (error) {
    toast.error(
      error?.response?.data?.message ||
        "We couldn't resume your plan just now. Please try again."
    );
    return false;
  }
};
